var BraintreePayPal = (function (braintree, $) {

    var types = {
        checkout: 'checkout',
        credit: 'credit'
    };

    var loadPaypalCheckout = function (cb) {
        var script = document.createElement('script');
        script.setAttribute('data-version-4', '');
        script.setAttribute('log-level', 'warn');

        script.onload = function () {
            cb && cb();
        };

        script.src = 'https://www.paypalobjects.com/api/checkout.js';
        document.body.appendChild(script);
    };

    var BraintreePayPal = function (opts) {
        this.$created = new $.Deferred();
        this.instance = null;
        this.currency = '$';
        this.env = opts.env;
        $.extend(this, opts);
    };

    $.extend(BraintreePayPal.prototype, {
        init: function (clientInstance) {
            var callback = $.proxy(this._callback, this, clientInstance);

            loadPaypalCheckout(function () {
                braintree.paypalCheckout.create({
                    client: clientInstance
                }, callback);
            });

            return this.$created.promise();
        },
        _callback: function (clientInstance, createErr, instance) {
            if (!createErr) this.instance = instance;
            this.$created.resolve(clientInstance);
        },
        createButton: function (selector, type, validate, pay, height, labelType) {
            var _this = this;
            var paypalCheckoutInstance = this.instance;

            paypal.Button.render({

                env: this.env, 
                locale: 'en_AU',
                style: {
                    size: 'responsive',
                    height: height || undefined,
                    color: type === types.credit && 'darkblue' || 'white',
                    shape: 'rect',
                    label: type === types.credit && 'credit' || labelType || undefined,
                    tagline: false,
                    layout: 'horizontal'
                },

                commit: true,

                payment: function (data, actions) {
                    return new paypal.Promise(validate)
                        .then(function (opts) {
                            if (opts.amount != null && opts.currencySing != null && opts.currency != null) {
                                opts.billingAgreementDescription = 'Purchase Amount ' + opts.currencySing + opts.amount;
                            }

                            var _opts = $.extend({}, {
                                flow: type === types.credit && 'checkout' || 'vault',
                                intent: 'sale',
                                offerCredit: type === types.credit, //true Only for MySale�s UK sites (pending approval)
                                enableShippingAddress: false
                            }, opts || {});

                            return paypalCheckoutInstance.createPayment(_opts);
                        });
                },

                onAuthorize: function (data, actions) {
                    // Execute the payment here, when the buyer approves the transaction   
                    return paypalCheckoutInstance.tokenizePayment(data).then(function (payload) {
                        pay({
                            Nonce: payload.nonce,
                            Type: 'braintree'
                        });
                    });
                },

                onCancel: function (data) {
                    // Handle closing the payment window or clicking the cancel link
                    //console.log('onCancel', data);
                },

                onError: function (err) {
                    // console.log('err', err);
                }
            }, selector);
        },
        isEnabled: function () {
            return !!this.instance;
        },
        ready: function (cb) {
            var _this = this;
            this.$created.done(function () {
                $.isFunction(cb) && cb(_this);
            });
        }
    });

    return BraintreePayPal;
})(window.braintree, jQuery);